let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a5Ksd")).then(() => parcelRequire('fc11e'));